import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "unitSystem",
    "mgDlBtn",
    "mmolLBtn",
    "advancedSection",
    "advancedToggleText"
  ]

  static values = {
    unit: { type: String, default: "mg/dL" },
    advancedExpanded: { type: Boolean, default: false }
  }

  connect() {
    // Get unit system from hidden field (for edit mode) or use default
    const unitSystemField = this.unitSystemTarget
    const initialUnit = unitSystemField.value || this.unitValue
    this.updateUnit(initialUnit)

    // Set default date to today if empty
    const dateInput = this.element.querySelector('input[type="date"]')
    if (dateInput && !dateInput.value) {
      dateInput.value = new Date().toISOString().split('T')[0]
    }

    // Check if advanced section should be visible initially (edit mode)
    if (this.hasAdvancedSectionTarget && !this.advancedSectionTarget.classList.contains('hidden')) {
      this.advancedExpandedValue = true
    }
  }

  switchToMgDl(event) {
    event.preventDefault()
    this.updateUnit("mg/dL")
  }

  switchToMmolL(event) {
    event.preventDefault()
    this.updateUnit("mmol/L")
  }

  updateUnit(unit) {
    this.unitValue = unit
    this.unitSystemTarget.value = unit

    // Update button styles - pill style like nav tabs
    if (unit === "mg/dL") {
      this.mgDlBtnTarget.className = "px-6 py-2 rounded-full text-sm font-semibold transition-all bg-white shadow-sm text-slate-900"
      this.mmolLBtnTarget.className = "px-6 py-2 rounded-full text-sm font-semibold transition-all text-slate-600 hover:text-slate-900"
    } else {
      this.mgDlBtnTarget.className = "px-6 py-2 rounded-full text-sm font-semibold transition-all text-slate-600 hover:text-slate-900"
      this.mmolLBtnTarget.className = "px-6 py-2 rounded-full text-sm font-semibold transition-all bg-white shadow-sm text-slate-900"
    }

    // Update placeholders based on unit
    this.updatePlaceholders(unit)
  }

  updatePlaceholders(unit) {
    const placeholders = {
      "mg/dL": {
        "reading[total_cholesterol]": "200",
        "reading[ldl]": "130",
        "reading[hdl]": "50",
        "reading[triglycerides]": "150",
        "reading[apo_b]": "90",
        "reading[apo_a1]": "130",
        "reading[lpa]": "30",
        "reading[vldl]": "30"
      },
      "mmol/L": {
        "reading[total_cholesterol]": "5.2",
        "reading[ldl]": "3.4",
        "reading[hdl]": "1.3",
        "reading[triglycerides]": "1.7",
        "reading[apo_b]": "2.3",
        "reading[apo_a1]": "3.4",
        "reading[lpa]": "0.8",
        "reading[vldl]": "0.8"
      }
    }

    const values = placeholders[unit]
    const inputs = this.element.querySelectorAll('input[type="number"]')

    inputs.forEach(input => {
      const name = input.name
      if (values[name]) {
        input.placeholder = values[name]
      }
    })
  }

  toggleAdvanced(event) {
    event.preventDefault()
    this.advancedExpandedValue = !this.advancedExpandedValue

    if (this.advancedExpandedValue) {
      this.advancedSectionTarget.classList.remove("hidden")
      this.advancedToggleTextTarget.textContent = "Hide Advanced Markers"
    } else {
      this.advancedSectionTarget.classList.add("hidden")
      this.advancedToggleTextTarget.textContent = "Show Advanced Markers"
    }
  }
}
